import { Injectable, ViewContainerRef } from '@angular/core';
import * as CryptoJS from 'crypto-js'; 
import { ModalDialogService } from 'ngx-modal-dialog';
import { Md5 } from 'ts-md5';
@Injectable({
  providedIn: 'root',
  
})
export class FunctService {
  microsoftAddress(microsoftAddress: any, arg1: { headers: import("@angular/common/http").HttpHeaders; }) {
    throw new Error('Method not implemented.');
  }

  public ipaddress: any;
  public appName: any;
  public secretKey: any;
  //public modalService: ModalDialogService,  public viewRef: ViewContainerRef
  constructor() {  
    this.appName="Thai 2D3D";  
   
    //prod
    this.ipaddress = "https://api.thai2d3dgame.com/api/"; 
    //testDev
    //this.ipaddress = "http://192.168.100.5:81/api/";
    this.secretKey="Yv9GlO0wX4peYxWCMGpUXM9ZKJBU78tc8cvSld5sN20";

  }
  encrypt(plainText: string): string
   {      
    var key = CryptoJS.enc.Utf8.parse('7061737323313233');
    var iv = CryptoJS.enc.Utf8.parse('7061737323313233');
    
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plainText), key,
      {
        keySize: 128,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    //console.log(encrypted.toString());
    return encrypted.toString();
   }
  getSignature(signature: string): string{
    var sin= Md5.hashStr(signature).toString();
    return sin;
   }
  
}
